module.exports = __webpack_public_path__ + "static/img/wechat-qr.997a348.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wechat-qr.png
// module id = nF5E
// module chunks = 1